import { render, staticRenderFns } from "./EbookContentSidebar.vue?vue&type=template&id=24991cac&scoped=true"
import script from "./EbookContentSidebar.vue?vue&type=script&lang=js"
export * from "./EbookContentSidebar.vue?vue&type=script&lang=js"
import style0 from "./EbookContentSidebar.vue?vue&type=style&index=0&id=24991cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24991cac",
  null
  
)

export default component.exports